import React from "react";
import {
  SIDEBAR_BOTTOM_MENU_ITEMS,
  getSidebarMenuItems,
} from "../../constants/SidebarConstants";
import { SidebarItemsCreator } from "../SidebarItemsCreator/SidebarItemsCreator";
import { StyledCloseIcon, StyledSidebar } from "./Sidebar.styled";
import { ReactComponent as Logo } from "../../images/logo.svg";
import { CaptionsTyp } from "../Typography/Typography";
import { ABSTRACT_MYCAREER_LABEL } from "../../constants/Dictionary";
import packageJson from "../../../package.json";
import { IconManager } from "../core/IconManager/IconManager";
import { IconSizeEnum } from "../../types/AppTypes";
import { ReactComponent as CloseIcon } from "../../icons/close.svg";
import { ReactComponent as MenuIcon } from "../../icons/menu.svg";
import { useAppSelector } from "../../hooks/store.hook";

type SidebarProps = {
  showSidebar: boolean;
  setShowSidebar: (show: boolean) => void;
};

export const Sidebar = ({ showSidebar, setShowSidebar }: SidebarProps) => {
  const { profile } = useAppSelector((state) => state.user);

  return (
    <StyledSidebar $showSidebar={showSidebar}>
      {showSidebar && (
        <>
          <StyledCloseIcon onClick={() => setShowSidebar(false)}>
            <IconManager size={IconSizeEnum.MEDIUM}>
              <CloseIcon />
            </IconManager>
          </StyledCloseIcon>
          <div className="title-app">
            <Logo />
          </div>
        </>
      )}
      {!showSidebar && (
        <div className="open-menu-container">
          <IconManager
            size={IconSizeEnum.MEDIUM}
            onClick={() => setShowSidebar(true)}
          >
            <MenuIcon />
          </IconManager>
        </div>
      )}
      <div className="items-container">
        <SidebarItemsCreator
          items={getSidebarMenuItems(profile)}
          showSidebar={showSidebar}
          closeSidebar={() => setShowSidebar(false)}
        />
      </div>
      <div className="bottom-container">
        <SidebarItemsCreator
          items={SIDEBAR_BOTTOM_MENU_ITEMS()}
          showSidebar={showSidebar}
          closeSidebar={() => setShowSidebar(false)}
        />
        {showSidebar && <CaptionsTyp>{ABSTRACT_MYCAREER_LABEL}</CaptionsTyp>}
        <CaptionsTyp>v{packageJson.version}</CaptionsTyp>
      </div>
    </StyledSidebar>
  );
};
